// The public editor pages (/editor and one page per tool, in English and
// Spanish). pages.json is the one list of them: the server's per-page <head>
// tags (FaceShot-ChopShop-web/lib/page-meta.js) and the sitemap are checked
// against it by tests/editor-page-meta.test.js.

import pages from "./pages.json";
import type { ToolId } from "@/components/chopbox/ui/state/types";

export type EditorPageKey = keyof typeof pages;
export type EditorLang = "en" | "es";

interface PageDef {
  tool: ToolId | null;
  en: string;
  es: string;
  /** The page's tool costs credits (Animate a photo): the page never calls itself free. */
  paid?: boolean;
}

const PAGES = pages as Record<EditorPageKey, PageDef>;

export const EDITOR_PAGE_KEYS = Object.keys(PAGES) as EditorPageKey[];

export function editorPath(key: EditorPageKey, lang: EditorLang): string {
  const slug = PAGES[key][lang];
  return slug ? `/editor/${slug}` : "/editor";
}

export function editorTool(key: EditorPageKey): ToolId | null {
  return PAGES[key].tool;
}

export function editorPaid(key: EditorPageKey): boolean {
  return PAGES[key].paid === true;
}

/** The page a /editor path shows, or null for an unknown slug. */
export function editorPageFor(slug: string | undefined): { key: EditorPageKey; lang: EditorLang } | null {
  const s = (slug ?? "").trim().toLowerCase();
  for (const key of EDITOR_PAGE_KEYS) {
    if (PAGES[key].en === s) return { key, lang: "en" };
    if (PAGES[key].es === s) return { key, lang: "es" };
  }
  return null;
}

/** "es-MX" → "es"; anything but Spanish reads as English. */
export function editorLang(language: string | undefined): EditorLang {
  return String(language ?? "").toLowerCase().startsWith("es") ? "es" : "en";
}
